(function () {
  function debounce(fn, delay) {
    var timer = null;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  function initInstance(form) {
    var wrapper = form.closest('.m-search-bar-bar');
    if (!wrapper || wrapper.dataset.searchBarInit === 'true') return;
    wrapper.dataset.searchBarInit = 'true';

    var input = form.querySelector('[data-search-bar-input]');
    var spinner = form.querySelector('[data-search-bar-spinner]');
    var results = wrapper.querySelector('[data-search-bar-results]');
    var cache = {};

    function hideResults() {
      results.hidden = true;
      results.innerHTML = '';
    }

    function showSpinner(show) {
      if (spinner) spinner.hidden = !show;
    }

    function fetchResults(query) {
      var routes = window.MinimogSettings && window.MinimogSettings.routes;
      if (!routes || !routes.predictive_search_url) return;

      if (cache[query]) {
        renderResults(cache[query]);
        return;
      }

      showSpinner(true);

      var url =
        routes.predictive_search_url +
        '?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=8' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search';

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-predictive-search');
          var markup = section ? section.innerHTML : '';
          cache[query] = markup;
          renderResults(markup);
        })
        .catch(function () {
          hideResults();
        })
        .finally(function () {
          showSpinner(false);
        });
    }

    function renderResults(markup) {
      if (!markup || !markup.trim()) {
        hideResults();
        return;
      }
      results.innerHTML = markup;
      results.hidden = false;
    }

    var debouncedFetch = debounce(function (query) {
      fetchResults(query);
    }, 300);

    input.addEventListener('input', function () {
      var query = input.value.trim();
      if (query.length < 2) {
        hideResults();
        return;
      }
      debouncedFetch(query);
    });

    input.addEventListener('focus', function () {
      var query = input.value.trim();
      if (query.length >= 2 && cache[query]) {
        renderResults(cache[query]);
      }
    });

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) hideResults();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hideResults();
    });
  }

  function init() {
    document.querySelectorAll('[data-search-bar-form]').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
